import { unsafeHTML } from "lit-html/directives/unsafe-html.js"
import {
  html,
  SYSAction,
  SYSConfig,
  SYSFeatures,
  SYSPermissions,
  SYSState,
} from "../../../../_ovlclient/src"
import { AppDefPermission } from "../../../../_ovlclient/src/config"
import {
  FeatureGet,
  SortGet,
} from "../../../../_ovlclient/src/global/globalapi"
import {
  _DeleteFeatureInfo,
  _SetFeatureInfo,
} from "../../../../_ovlclient/src/global/globals"
import {
  HookTableInit_Type,
  HookTableRowAttributeGetProperties_ReturnType,
  HookTableRowAttributeGetProperties_Type,
  HookTableRowAttributesGetAllAttributes_ReturnType,
  HookTableRowAttributesGetAllAttributes_Type,
  HookTableRowAttributesGetAttributes_ReturnType,
  HookTableRowAttributesGetAttributes_Type,
  HookTableRowFnCan_Type,
  type HookFieldGetList_ReturnType,
  type HookFieldGetList_Type,
  type HookFieldGetValueRender_ReturnType,
  type HookFieldGetValueRender_Type,
  type HookFormChanged_Type,
  type HookFormInit_ReturnType,
  type HookFormInit_Type,
  type HookFormValidate_Type,
  type HookLookupsRefresh_ReturnType,
  type HookLookupsRefresh_Type,
  type HookTableAfterDelete_Type,
  type HookTableAfterSave_Type,
  type HookTableCustomFilter_ReturnType,
  type HookTableCustomFilter_Type,
  type HookTableCustomSort_ReturnType,
  type HookTableCustomSort_Type,
  type HookTableRowFn_Type,
} from "../../../../_ovlclient/src/global/hooks"
import { DialogOpen } from "../../../../_ovlclient/src/library/dialog/dialogapi"
import {
  FieldIsValid,
  FieldSetState,
  FieldSetVal,
  FieldVal,
} from "../../../../_ovlclient/src/library/forms/fieldapi"
import {
  FormSetGroupState,
  SYSFormState,
} from "../../../../_ovlclient/src/library/forms/formapi"

import {
  TableCellVal,
  TableGet,
  TableRefresh,
  TableSelectRow,
} from "../../../../_ovlclient/src/library/table/tableapi"
import { T } from "../../../../_ovlclient/src/textapi"
import { SnackAdd } from "../../../src/library/snackapi"
import { RefreshResultingPermission } from "./helpers"
import { UserAdministration_PermissionType } from "./permission/tabledef"
import { UserAdministration_RoleType } from "./role/tabledef"
import { UserAdministration_UserType } from "./user/tabledef"
import { UserAdministration_UserRoleType } from "./userrole/tabledef"

const HookTableRowAttributesGetAttributes: SYSAction<
  HookTableRowAttributesGetAttributes_Type,
  HookTableRowAttributesGetAttributes_ReturnType
> = (value) => {
  if (value.defId === "SYSUserAdministration_User") {
    let type = value.rowAttributeDefKey.substring(
      value.rowAttributeDefKey.length - 3,
      value.rowAttributeDefKey.length
    )
    let roles: string[] = <string[]>value.row["Roles"]
    return roles.filter((f) => f.startsWith(type))
  } else if (value.defId === "SYSUserAdministration_Role") {
    let permissions: string = <any>value.row["U_PrtPermissions"]
    if (permissions === null || permissions === undefined) {
      return undefined
    }
    let type = value.rowAttributeDefKey.substring(
      value.rowAttributeDefKey.length - 3,
      value.rowAttributeDefKey.length
    )
    return Object.keys(JSON.parse(permissions)).filter((f) =>
      f.startsWith(type)
    )
  }
}

const HookTableRowAttributeGetProperties: SYSAction<
  HookTableRowAttributeGetProperties_Type,
  HookTableRowAttributeGetProperties_ReturnType
> = (value) => {
  if (value.defId === "SYSUserAdministration_User") {
    let roleTable = TableGet("SYSUserAdministration_Role")
    let found = roleTable.getKeys({ byIdValue: value.rowAttributeKey })
    return { tooltip: roleTable.rows[found[0]]["U_RoleDesc"] }
  } else if (value.defId === "SYSUserAdministration_Role") {
    return {
      tooltip: T(`SYSUserAdministrationPermission${value.rowAttributeKey}`),
    }
  }
}

const HookTableRowAttributesGetAllAttributes: SYSAction<
  HookTableRowAttributesGetAllAttributes_Type,
  HookTableRowAttributesGetAllAttributes_ReturnType
> = (value) => {
  if (value.defId === "SYSUserAdministration_User") {
    let type = value.rowAttributeDefKey.substring(
      value.rowAttributeDefKey.length - 3,
      value.rowAttributeDefKey.length
    )
    let tb = TableGet("SYSUserAdministration_Role")
    return {
      allAttributes: Object.keys(tb.rows)
        .filter((f) => tb.rows[f].Code.startsWith(type))
        .map((m) => tb.rows[m].Code),
    }
  } else if (value.defId === "SYSUserAdministration_Role") {
    let tb = TableGet("SYSUserAdministration_Role")
    let allAttributesSet = new Set()
    let type = value.rowAttributeDefKey.substring(
      value.rowAttributeDefKey.length - 3,
      value.rowAttributeDefKey.length
    )
    Object.keys(tb.rows)
      .filter((f) => tb.rows[f].U_PrtPermissions)
      .forEach((f) => {
        Object.keys(JSON.parse(tb.rows[f].U_PrtPermissions))
          .filter((f) => f.startsWith(type))
          .forEach((k) => {
            allAttributesSet.add(k)
          })
      })
    return { allAttributes: Array.from(allAttributesSet).sort() }
  }
}

const HookField_CardCode_GetList: SYSAction<
  HookFieldGetList_Type,
  HookFieldGetList_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  return state.ovl.features.SYSUserAdministration.lookups.CardCode
}

const HookField_Grp_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type<UserAdministration_UserRoleType>,
  HookFieldGetValueRender_ReturnType
> = (value) => {
  return {
    res: (value.row["U_RoleCode"] !== undefined
      ? value.row["U_RoleCode"]
      : value.row["Code"]
    ).substring(0, 3),
  }
}

const HookField_AuthMode_GetList: SYSAction<
  HookFieldGetList_Type,
  HookFieldGetList_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let authDefault =
    state.ovl.features.SYSUserAdministration.tables.SYSUserAdministration_User
      .ext.authDefault
  return {
    data: {
      UseDefault: {
        AuthModeCode: "UseDefault",
        AuthModeDescription: `Use Default (${authDefault.Mode} / ${
          authDefault.TOTP.ValidForDays !== -1
            ? `${authDefault.TOTP.ValidForDays} days`
            : "Session"
        })`,
      },
      UserPw: { AuthModeCode: "UserPw", AuthModeDescription: "User Password" },
      UserPwTOTP: {
        AuthModeCode: "UserPwTOTP",
        AuthModeDescription: "User Password with 2FA",
      },
    },
  }
}

const HookField_TOTPValidForDays_GetList: SYSAction<
  HookFieldGetList_Type,
  HookFieldGetList_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  return {
    data: {
      [-1]: {
        TOTPValidForDaysCode: -1,
        TOTPValidForDaysDescription: "Same as Session",
      },
      [3]: {
        TOTPValidForDaysCode: 3,
        TOTPValidForDaysDescription: "3 days",
      },
      [7]: {
        TOTPValidForDaysCode: 7,
        TOTPValidForDaysDescription: "7 days",
      },
      [14]: {
        TOTPValidForDaysCode: 14,
        TOTPValidForDaysDescription: "14 days",
      },
      [30]: {
        TOTPValidForDaysCode: 30,
        TOTPValidForDaysDescription: "30 days",
      },
    },
  }
}

const HookField_U_RoleCode_GetList: SYSAction<
  HookFieldGetList_Type,
  HookFieldGetList_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  // return all not already assigned roles
  let data
  let allData = GetRoleDataLookup(state)
  let allDataKeys = Object.keys(allData)
  let tableData = TableGet<UserAdministration_UserRoleType>(
    "SYSUserAdministration_UserRole"
  )
  let lookupDef =
    state.ovl.features.SYSUserAdministration.lookups.RoleCode.lookupDef
  let currentId: any = -1
  let idField = "Id"
  if (state.ovl.app.backendType === "SAP") {
    idField = "Code"
  }
  if (value.formState) {
    currentId = value.formState.row[idField]
  }

  // make sure SYSRoleAdmin is not even in the list for regular users
  let hasSYSRoleAdmin =
    FeatureGet("SYSRoleAdmin").Found() || state.ovl.user.role === "Admin"
  data = allDataKeys
    .filter((k) => hasSYSRoleAdmin || allData[k].U_RoleCode !== "SYSRoleAdmin")
    .filter(
      (k) =>
        !tableData
          .getKeys()
          .some(
            (s) =>
              tableData.rows[s][idField] !== currentId &&
              tableData.rows[s].U_RoleCode === k
          )
    )
    .reduce((val, k) => {
      val[k] = allData[k]
      return val
    }, {})
  return { data, lookupDef }
}
const GetRoleDataLookup = (state: SYSState) => {
  let roleData =
    state.ovl.features.SYSUserAdministration.tables.SYSUserAdministration_Role
      .data
  return Object.keys(roleData).reduce((val, k) => {
    let row = <UserAdministration_RoleType>roleData[k]
    val[row.Code] = {
      U_RoleCode: row.Code,
      U_RoleDesc: row.U_RoleDesc,
      Role_U_Val1: row.U_Val1,
      Role_U_Val2: row.U_Val2,
      Role_U_Text1: row.U_Text1,
      Role_U_Text2: row.U_Text2,
      Role_U_Text3: row.U_Text3,
      Role_U_Json1: row.U_Json1,
    }
    return val
  }, {})
}

const AssignUserRoleInfoValues = (
  formState: SYSFormState,
  row: UserAdministration_RoleType
) => {
  // set info val1,val2,text1,text2 values coming from role
  if (formState.fields["U_Val1"]) {
    formState.fields["U_Val1"].ui.infoValue = row["Role_U_Val1"]
  }
  if (formState.fields["U_Val2"]) {
    formState.fields["U_Val2"].ui.infoValue = row["Role_U_Val2"]
  }
  if (formState.fields["U_Text1"]) {
    formState.fields["U_Text1"].ui.infoValue = row["Role_U_Text1"]
  }
  if (formState.fields["U_Text2"]) {
    formState.fields["U_Text2"].ui.infoValue = row["Role_U_Text2"]
  }
  if (formState.fields["U_Text3"]) {
    formState.fields["U_Text3"].ui.infoValue = row["Role_U_Text3"]
  }
  if (formState.fields["U_Json1"]) {
    formState.fields["U_Json1"].ui.infoValue = row["Role_U_Json1"]
  }
}

// const HookTableCustomTitle: SYSAction<
//   HookTableCustomTitle_Type,
//   HookTableCustomTitle_ReturnType
// > = (value, { global }) => {
// }

const HookLookupsRefresh: SYSAction<
  HookLookupsRefresh_Type,
  HookLookupsRefresh_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  if (value.tableDefId === "SYSUserAdministration_User") {
    return {
      CardCode: state.ovl.features.SYSUserAdministration.lookups.CardCode,
    }
  } else if (value.tableDefId === "SYSUserAdministration_UserRole") {
    return {
      U_RoleCode: state.ovl.features.SYSUserAdministration.lookups.RoleCode,
    }
  }
}

const HookTableRowFnCan: SYSAction<
  HookTableRowFnCan_Type<
    UserAdministration_PermissionType & UserAdministration_UserType
  >
> = async (value, { global }) => {
  if (value.tableDef.id === "SYSUserAdministration_User") {
    // disallow actions if non admin is on admin row
    let isAdmin = global.getState().ovl.user.role === "Admin"
    if (!isAdmin && value.row.U_ITFPrtUserId === "Admin") {
      value.set("SendTOTPQRCode", { visibility: "NotVisible" })
      value.set("SendCredentials", { visibility: "NotVisible" })
      value.set("SYSEdit", { visibility: "NotVisible" })
      value.set("SYSDelete", { visibility: "NotVisible" })
      value.set("AssignRoles", { visibility: "NotVisible" })
      return
    }
    let defaultMode = global.getState().ovl.app.defaultAuthMode
    let mode = value.row.U_ITFPrtUserData.Auth.Mode
    if (
      !(
        mode === "UserPwTOTP" ||
        (mode === "UseDefault" && defaultMode === "UserPwTOTP")
      )
    ) {
      value.set("SendTOTPQRCode", { visibility: "NotVisible" })
    }
  }
}

const HookTableRowFn: SYSAction<
  HookTableRowFn_Type<
    UserAdministration_PermissionType & UserAdministration_UserType
  >
> = async (value) => {
  switch (value.fnKey) {
    case "AssignRoles":
      await TableRefresh("SYSUserAdministration_UserRole", {
        forcedFilters: { staticFilter: { U_CntctCode: value.row.CntctCode } },
        suppressBusySnack: true,
      })
      await TableRefresh("SYSUserAdministration_ResultingPermission", {
        serverFilter: {
          RoleCode: "@@SYSGetResultingRole",
          Permission: value.row.CntctCode,
        },
        resetStrategy: { ClearData: true },
      })

      DialogOpen("SYSUserAdministration_UserRole")
      break
    case "HandleRolePermission":
      // prepare all the permissions
      // by using the defaults in appdef and enrich/overwrite them with the one from the role
      // and create a table out of it so it can be used with regular tableforms
      if (value.def.id === "SYSUserAdministration_UserRole") {
        // if started from userrole initialise role and select role
        await TableRefresh("SYSUserAdministration_Role", {
          serverFilter: { Code: value.row["U_RoleCode"] },
          suppressBusySnack: true,
        })
        let roleTable = TableGet<UserAdministration_RoleType>(
          "SYSUserAdministration_Role",
          { byIdValue: value.row["U_RoleCode"] }
        )
        TableSelectRow("SYSUserAdministration_Role", roleTable.getKeys()[0], {
          mode: "Select",
        })
      }

      let roleTable = TableGet<UserAdministration_RoleType>(
        "SYSUserAdministration_Role",
        { byKeys: "Selected" }
      )
      let selectedRoleCode = roleTable.rows[roleTable.getKeys()[0]].Code
      let permissionData: UserAdministration_PermissionType[] = []
      let rolePermissions = JSON.parse(
        roleTable.rows[roleTable.getKeys()[0]].U_PrtPermissions
      )
      let preconfiguredPermissions: {
        [key in SYSPermissions]: AppDefPermission
      } = <any>SYSConfig.app.permissions
      let i = 0
      Object.keys(preconfiguredPermissions).forEach((f) => {
        let templatePermission: AppDefPermission = preconfiguredPermissions[f]
        permissionData.push({})
        permissionData[i].RoleCode = selectedRoleCode
        permissionData[i].Read = false
        permissionData[i].Modify = false
        permissionData[i].Add = false
        permissionData[i].Delete = false
        permissionData[i].Permission = f
        permissionData[i].HasPermission = false
        // now see if there is a userpermission for this permission
        if (rolePermissions) {
          Object.keys(rolePermissions).forEach((f2: SYSPermissions) => {
            if (f2 === f) {
              let userPermission = rolePermissions[f2]
              permissionData[i].HasPermission = true

              permissionData[i].Read = !!userPermission.modifiers.R
              permissionData[i].Modify = !!userPermission.modifiers.M
              permissionData[i].Add = !!userPermission.modifiers.A
              permissionData[i].Delete = !!userPermission.modifiers.D
            }
          })
        }
        i++
      })

      await TableRefresh("SYSUserAdministration_Permission", {
        localData: permissionData,
        forcedFilters: { staticFilter: { RoleCode: selectedRoleCode } },
      })

      DialogOpen("SYSUserAdministration_Permission")
  }
}

const HookField_PermissionDesc_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type<UserAdministration_PermissionType>,
  HookFieldGetValueRender_ReturnType
> = (value) => {
  return { res: T(`SYSUserAdministrationPermission${value.row.Permission}`) }
}

const HookFormInit: SYSAction<HookFormInit_Type> = async (value) => {
  let formState = value.formState
  let notRelevantFields: string[] = []
  let notRelevantGroups: string[] = []

  if (formState.tableDefId === "SYSUserAdministration_Permission") {
    let fields = formState.fields

    let permissionVal = TableCellVal(
      "SYSUserAdministration_Permission",
      value.formState.tableRowKey,
      "Permission"
    )
    let def: AppDefPermission = SYSConfig.app.permissions[permissionVal]

    let permissionDescField = fields["PermissionDesc"]
    permissionDescField.value = T(
      `SYSUserAdministrationPermission${permissionVal}`
    )
    if (!def.useModifiers) {
      notRelevantGroups.push("1")
    }

    return <HookFormInit_ReturnType>{
      fieldsToRemove: notRelevantFields,
      groupsToRemove: notRelevantGroups,
    }
  } else if (value.formState.tableDefId === "SYSUserAdministration_UserRole") {
    AssignUserRoleInfoValues(value.formState, value.formState.row)
  } else if (value.formState.tableDefId === "SYSUserAdministration_User") {
    let userDataField = value.formState.fields["U_ITFPrtUserData"]
    let userData = await FieldVal(value.formState.fields["U_ITFPrtUserData"])
    if (!userData) {
      userData = {
        Auth: {
          Mode: "UseDefault",
          TOTP: { ValidForDays: -1 },
        },
      }
      value.formState.fields["U_ITFPrtUserData"].convertedValue = userData
    }
    let authMode = userData?.Auth?.Mode
    //todo set defaults if new user (user add in itf_prt_testcases)
    let totpValidForDays = userData.Auth.TOTP.ValidForDays
    await FieldSetVal(
      value.formState.fields["TOTPValidForDays"],
      totpValidForDays
    )
    await FieldSetVal(value.formState.fields["AuthMode"], authMode)
    await FieldSetState(userDataField, false, {
      mode: "visible/notvisible",
    })
  }
}

const HookFormValidate: SYSAction<HookFormValidate_Type> = (value) => {
  if (value.formState.tableDefId === "SYSUserAdministration_User") {
    if (value.field.fieldKey === "E_MailL") {
      value.validatorUse("EmailList")
    }
  }
}

const HookFormChanged: SYSAction<HookFormChanged_Type> = async (
  value,
  { global, execution }
) => {
  let state = global.getState()
  if (value.formState.tableDefId === "SYSUserAdministration_Permission") {
    let formState = value.formState
    let hasPermission = FieldVal(formState.fields.HasPermission)
    FormSetGroupState(formState, 1, hasPermission, {
      mode: "visible/readonly",
    })
  } else if (
    value.formState.tableDefId === "SYSUserAdministration_UserRole" ||
    value.formState.tableDefId === "SYSUserAdministration_Role"
  ) {
    if (
      value.changedField.fieldKey === "U_Json1" &&
      value.changedField.isValid &&
      value.changedField.newValue
    ) {
      let parsed

      try {
        parsed = JSON.parse(value.changedField.newValue)
        let intendedVal = JSON.stringify(parsed, null, 2)
        if (intendedVal !== value.changedField.newValue) {
          await FieldSetVal(value.changedField.field, intendedVal, {
            userTriggered: false,
          })
          return
        }
      } catch (e: any) {
        value.validationsAdd(
          "SYSUserAdministrationJson1ValidationInvalidJson",
          {
            validation: { translationReps: [e.message] },
          }
        )
        execution.handled = true
        return
      }
      if (
        (value.formState.tableDefId === "SYSUserAdministration_UserRole" &&
          value.fields["U_RoleCode"].convertedValue === "SYSTableSettings") ||
        (value.formState.tableDefId === "SYSUserAdministration_Role" &&
          value.fields["Code"].convertedValue === "SYSTableSettings")
      ) {
        let hint = ""
        const validLevels = ["own", "company", "all"]
        const levelScores = { own: 1, company: 2, all: 3 }

        if (!parsed.startsWith || typeof parsed.startsWith !== "object") {
          hint = "Configuration must contain a 'startsWith' object."
        } else {
          for (const key of Object.keys(parsed.startsWith)) {
            const tableConfig = parsed.startsWith[key]
            if (!tableConfig || !tableConfig.Favorites) {
              hint = `Key '${key}' must contain a 'Favorites' object.`
              break
            }
            const fav = tableConfig.Favorites
            const validKeys = ["readLevel", "modifyLevel"]
            if (Object.keys(fav).some((k) => !validKeys.includes(k))) {
              hint = `Favorites in '${key}' only allows 'readLevel' and 'modifyLevel' keys.`
              break
            } else if (!fav.readLevel || !validLevels.includes(fav.readLevel)) {
              hint = `Property 'readLevel' in '${key}' is required and must be 'own', 'company' or 'all'.`
              break
            } else if (
              fav.modifyLevel &&
              !validLevels.includes(fav.modifyLevel)
            ) {
              hint = `Property 'modifyLevel' in '${key}' must be 'own', 'company' or 'all'.`
              break
            } else if (
              fav.modifyLevel &&
              levelScores[fav.modifyLevel] > levelScores[fav.readLevel]
            ) {
              hint = `'modifyLevel' in '${key}' cannot be higher than 'readLevel' (all > company > own).`
              break
            }
          }
        }

        if (hint) {
          value.validationsAdd(
            "SYSUserAdministrationJson1ValidationSYSTableSettings",
            {
              validation: {
                translationReps: [hint],
              },
            }
          )
          execution.handled = true
          return
        }
      }
    }

    if (
      value.changedField.validValueChanged &&
      value.changedField.fieldKey === "U_RoleCode"
    ) {
      let lookupData = GetRoleDataLookup(state)
      FieldSetVal(
        value.fields["U_RoleDesc"],
        lookupData[value.changedField.newValue]["U_RoleDesc"]
      )
      FieldSetVal(value.fields["U_Val1"], null)
      FieldSetVal(value.fields["U_Val2"], null)
      FieldSetVal(value.fields["U_Text1"], null)
      FieldSetVal(value.fields["U_Text2"], null)
      FieldSetVal(value.fields["U_Text3"], null)
      FieldSetVal(value.fields["U_Json1"], null)

      AssignUserRoleInfoValues(
        value.formState,
        lookupData[value.changedField.newValue]
      )
    }
  } else if (value.formState.tableDefId === "SYSUserAdministration_User") {
    if (
      value.changedField.fieldKey === "AuthMode" &&
      value.changedField.isValid
    ) {
      await FieldSetState(
        value.fields["TOTPValidForDays"],
        value.changedField.newValue &&
          value.changedField.newValue.indexOf("TOTP") > -1,
        { mode: "visible/notvisible" }
      )
    }
    if (
      (value.changedField.fieldKey === "AuthMode" ||
        value.changedField.fieldKey === "TOTPValidForDays") &&
      value.changedField.validValueChanged &&
      !value.changedField.fromInit
    ) {
      let userData = await FieldVal(value.fields["U_ITFPrtUserData"])
      if (value.changedField.fieldKey === "AuthMode") {
        userData.Auth.Mode = value.changedField.newValue
        await FieldSetVal(value.fields["U_ITFPrtUserData"], userData)
      }
      if (value.changedField.fieldKey === "TOTPValidForDays") {
        userData.Auth.TOTP.ValidForDays = value.changedField.newValue
        await FieldSetVal(value.fields["U_ITFPrtUserData"], userData)
      }
    }
  }
}

const HookTableAfterSave: SYSAction<HookTableAfterSave_Type> = async (
  value
) => {
  if (value.formState.tableDefId === "SYSUserAdministration_Permission") {
    let roleTable = TableGet<UserAdministration_RoleType>(
      "SYSUserAdministration_Role",
      { byKeys: "Selected" }
    )
    let selectedRoleCode = roleTable.rows[roleTable.getKeys()[0]].Code
    // also update underlying role table
    TableRefresh("SYSUserAdministration_Role", {
      serverFilter: { Code: selectedRoleCode },
    })
  } else if (value.formState.tableDefId === "SYSUserAdministration_UserRole") {
    // Keep local Featureinfo in sync (they get loaded initially on login)
    let f = value.res.data[0]
    _SetFeatureInfo(
      f.U_CntctCode,
      f.U_RoleCode,
      f.U_Text1 ? f.U_Text1 : f.Role_U_Text1,
      f.U_Text2 ? f.U_Text2 : f.Role_U_Text2,
      f.U_Text3 ? f.U_Text3 : f.Role_U_Text3,
      f.U_Json1 ? f.U_Json1 : f.Role_U_Json1,
      f.U_Val1 ? f.U_Val1 : f.Role_U_Val1,
      f.U_Val2 ? f.U_Val2 : f.Role_U_Val2
    )
    TableRefresh("SYSUserAdministration_User", {
      serverFilter: { CntctCode: f.U_CntctCode },
    })
    RefreshResultingPermission(f.U_CntctCode)
  } else if (value.formState.tableDefId === "SYSUserAdministration_Role") {
    let userRoleTable = TableGet<UserAdministration_UserRoleType>(
      "SYSUserAdministration_UserRole",
      { byKeys: "Selected" }
    )
    if (userRoleTable.getKeys().length > 0) {
      let selectedRoleCode =
        userRoleTable.rows[userRoleTable.getKeys()[0]].U_RoleCode

      let userTable = TableGet<UserAdministration_UserType>(
        "SYSUserAdministration_User",
        { byKeys: "Selected" }
      )
      if (userTable.getKeys().length > 0) {
        let selectedUser = userTable.rows[userTable.getKeys()[0]].CntctCode
        TableRefresh("SYSUserAdministration_UserRole", {
          serverFilter: {
            U_CntctCode: selectedUser,
            U_RoleCode: selectedRoleCode,
          },
        })
      }
    }
  }
}

const HookTableAfterDelete: SYSAction<HookTableAfterDelete_Type> = async (
  value
) => {
  if (value.def.id === "SYSUserAdministration_UserRole") {
    let deletedRow: UserAdministration_UserRoleType = value.deletedRow
    // Keep local Featureinfo in sync
    _DeleteFeatureInfo(
      deletedRow.U_CntctCode,
      <SYSFeatures>deletedRow.U_RoleCode
    )

    RefreshResultingPermission(deletedRow.U_CntctCode)
    // also refresh users because eg. when we remove prssales role the prs fileds will be deleted
    TableRefresh("SYSUserAdministration_User", {
      serverFilter: {
        CntctCode: deletedRow.U_CntctCode,
      },
    })
  }
}

const HookField_U_Val1_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type<UserAdministration_UserRoleType>,
  HookFieldGetValueRender_ReturnType
> = (value) => {
  if (value.tableDef.id === "SYSUserAdministration_UserRole") {
    let res
    let val
    if (value.row.U_Val1 === null) {
      val = value.row.Role_U_Val1
      res = html`<i>${val}</i>`
    } else {
      val = value.row.U_Val1
      res = html`${val}`
    }
    return { res, valueRaw: val }
  }
}
const HookField_U_Val2_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type<UserAdministration_UserRoleType>,
  HookFieldGetValueRender_ReturnType
> = (value) => {
  if (value.tableDef.id === "SYSUserAdministration_UserRole") {
    let res
    let val
    if (value.row.U_Val2 === null) {
      val = value.row.Role_U_Val2
      res = html`<i>${val}</i>`
    } else {
      val = value.row.U_Val2
      res = html`${val}`
    }
    return { res, valueRaw: val }
  }
}

const HookField_U_Text1_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type<UserAdministration_UserRoleType>,
  HookFieldGetValueRender_ReturnType
> = (value) => {
  if (value.tableDef.id === "SYSUserAdministration_UserRole") {
    let res
    let val
    if (!value.row.U_Text1) {
      val = value.row.Role_U_Text1
      res = html`<i>${val}</i>`
    } else {
      val = value.row.U_Text1
      res = html`${val}`
    }
    return { res, valueRaw: val }
  }
}
const HookField_U_Text2_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type<UserAdministration_UserRoleType>,
  HookFieldGetValueRender_ReturnType
> = (value) => {
  if (value.tableDef.id === "SYSUserAdministration_UserRole") {
    let res
    let val
    if (!value.row.U_Text2) {
      val = value.row.Role_U_Text2
      res = html`<i>${val}</i>`
    } else {
      val = value.row.U_Text2
      res = html`${val}`
    }
    return { res, valueRaw: val }
  }
}

const HookField_U_Text3_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type<UserAdministration_UserRoleType>,
  HookFieldGetValueRender_ReturnType
> = (value) => {
  if (value.tableDef.id === "SYSUserAdministration_UserRole") {
    let res
    let val
    if (!value.row.U_Text3) {
      val = value.row.Role_U_Text3
      res = html`<i>${val}</i>`
    } else {
      val = value.row.U_Text3
      res = html`${val}`
    }
    return { res, valueRaw: val }
  }
}

const HookField_U_Json1_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type<UserAdministration_UserRoleType>,
  HookFieldGetValueRender_ReturnType
> = (value) => {
  if (value.tableDef.id === "SYSUserAdministration_UserRole") {
    let res
    let val
    if (!value.row.U_Json1) {
      val = value.row.Role_U_Json1
      res = html`<i>${val}</i>`
    } else {
      val = value.row.U_Json1
      res = html`${val}`
    }
    return { res, valueRaw: val }
  }
}
const HookTableCustom_ValidUsers_Filter: SYSAction<
  HookTableCustomFilter_Type<UserAdministration_UserType>,
  HookTableCustomFilter_ReturnType
> = (value) => {
  let table = TableGet<UserAdministration_UserType>(
    "SYSUserAdministration_User",
    {
      byKeys: "SelectedTimeDesc",
    }
  )
  let selectedUserId = table.rows[table.getKeys()[0]].CntctCode
  return (
    value.row.U_ITFPrtUserId !== "Admin" &&
    value.row.CntctCode !== selectedUserId
  )
}

const HookField_AuthMode_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type<UserAdministration_UserType>,
  HookFieldGetValueRender_ReturnType
> = (value, { global }) => {
  let mode = value.row.U_ITFPrtUserData.Auth.Mode
  let validForDays = value.row.U_ITFPrtUserData.Auth.TOTP.ValidForDays
  let authDefault =
    global.getState().ovl.features.SYSUserAdministration.tables
      .SYSUserAdministration_User.ext.authDefault

  if (mode === "UseDefault") {
    mode = `${mode} (${authDefault.Mode})`

    validForDays = authDefault.TOTP.ValidForDays
  }

  return {
    res: unsafeHTML(
      `Mode: ${mode} <wbr>${
        mode.indexOf("TOTP") > -1 && validForDays !== -1
          ? `<br/>TOTP valid for ${validForDays} days`
          : ""
      }`.replace(/\s+/g, " ")
    ),
  }
}

const HookTableInit: SYSAction<HookTableInit_Type> = (value, { global }) => {
  if (value.isInitialised) {
    return
  }
  if (value.context !== "before") {
    return
  }
  if (
    value.tableDef.id === "SYSUserAdministration_User" ||
    value.tableDef.id === "SYSUserAdministration_Role"
  ) {
    let state = global.getState()
    // setup Roles Attributes Filter now that everything should be ready
    let initial_rowAttributes = {}
    let validFeaturesGrp = Object.keys(SYSConfig.app.features).reduce(
      (val, k) => {
        let key = k
        if (k !== "MODAttachments") {
          key = k.substring(0, 3)
          val[key] = true
        }
        return val
      },
      {}
    )
    let grpMainKeys = Object.keys(validFeaturesGrp)
    grpMainKeys.forEach((grpKey) => {
      grpKey = `Grp${grpKey}`
      if (!initial_rowAttributes[grpKey]) {
        initial_rowAttributes[grpKey] = {
          useCount: true,
          showInTitle: true,
          translationKey: `SYSFeature${grpKey}`,
        }
      }
    })
    value.tableDef.options.initial_rowAttributes = initial_rowAttributes
  }
  let state = global.getState()
  if (
    value.tableDef.id === "SYSUserAdministration_UserRole" ||
    value.tableDef.id === "SYSUserAdministration_UserRoleTransfer"
  ) {
    if (state.ovl.app.backendType === "SAP") {
      value.tableDef.database.dataIdField = "Code"
      value.tableDef.database.dbInsertMode = "UDTAutoGUIDBoth"
    }
  } else if (value.tableDef.id === "SYSUserAdministration_User") {
    if (state.ovl.app.backendType === "SAP") {
      Object.keys(value.tableDef.columns).forEach((c) => {
        if (
          c !== "U_ITFPrtUserData" &&
          c !== "AuthMode" &&
          c !== "TOTPValidForDays"
        ) {
          value.tableDef.columns[c].ui.visibility = "Table"
        }
      })
    }
  }
}

export let hooks = {
  HookTableInit,
  HookTableRowAttributesGetAttributes,
  HookTableRowAttributesGetAllAttributes,
  HookTableRowAttributeGetProperties,
  HookField_CardCode_GetList,
  HookField_U_RoleCode_GetList,
  HookField_AuthMode_GetList,
  HookField_TOTPValidForDays_GetList,
  HookLookupsRefresh,
  HookTableRowFn,
  HookField_PermissionDesc_GetValueRender,
  HookField_Grp_GetValueRender,
  HookFormInit,
  HookFormValidate,
  HookFormChanged,

  // HookField_U_RoleCode_GetEditHint,
  HookTableAfterSave,
  HookTableAfterDelete,
  HookField_U_Val1_GetValueRender,
  HookField_U_Val2_GetValueRender,
  HookField_U_Text1_GetValueRender,
  HookField_U_Text2_GetValueRender,
  HookField_U_Text3_GetValueRender,
  HookField_U_Json1_GetValueRender,
  HookTableCustom_ValidUsers_Filter,
  HookField_AuthMode_GetValueRender,
  HookTableRowFnCan,
  // HookTableCustom_Test_Filter,
  // HookTableCustom_Test_Sort,
}
